import type { ReactNode } from 'react';
import { theme } from 'antd';
import type { OutcomeTone } from './OutcomeTone';
import { outcomeToneTokens } from './OutcomeTone';

interface OutcomeIconProps {
  tone: OutcomeTone;
  /** `filled` for something that happened, `outlined` for something that did not. */
  variant: 'filled' | 'outlined';
  children: ReactNode;
}

/** The badge on an `OutcomeRow`: one glyph in a 28px circle. */
export const OutcomeIcon = ({ tone, variant, children }: OutcomeIconProps) => {
  const { token } = theme.useToken();
  const c = outcomeToneTokens(tone, token);
  const base = {
    width: 28,
    height: 28,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  } as const;

  return (
    <span
      style={
        variant === 'filled'
          ? { ...base, background: c.icon, color: token.colorWhite }
          : {
              ...base,
              border: `${token.lineWidth}px dashed ${c.icon}`,
              color: c.icon,
            }
      }
    >
      {children}
    </span>
  );
};
